export const styles = {
  tabList: { backgroundColor: '#000' },
  tabs: { width: 240, textAlign: 'center', color: '#fff', fontSize: 14 }
};
